export default "__VITE_ASSET__631e9071__"